import React from 'react';
import Style from './horizontal_divider.module.scss';

export function HorizontalDivider(props){

      return (
     <div className={Style.divider}></div>
      );
}